export const RELATORIO_JOB_FETCH_PREVIEW = 'RELATORIO_JOB_FETCH_PREVIEW';
export const RELATORIO_JOB_FETCH_PREVIEW_SUCCESS = 'RELATORIO_JOB_FETCH_PREVIEW_SUCCESS';
export const RELATORIO_JOB_START_AUDITORIA_FAIXA = 'RELATORIO_JOB_START_AUDITORIA_FAIXA';
export const RELATORIO_JOB_START_SUCCESS = 'RELATORIO_JOB_START_SUCCESS';
export const RELATORIO_JOB_DOWNLOAD = 'RELATORIO_JOB_DOWNLOAD';
export const RELATORIO_JOB_DOWNLOAD_DONE = 'RELATORIO_JOB_DOWNLOAD_DONE';
export const RELATORIO_JOB_CLEAN = 'RELATORIO_JOB_CLEAN';
